/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportingMelcoMachineStatisticsModelsValidateAccessToken
 */
export interface ReportingMelcoMachineStatisticsModelsValidateAccessToken {
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsValidateAccessToken
     */
    access_token?: string | null;
}

export function ReportingMelcoMachineStatisticsModelsValidateAccessTokenFromJSON(json: any): ReportingMelcoMachineStatisticsModelsValidateAccessToken {
    return ReportingMelcoMachineStatisticsModelsValidateAccessTokenFromJSONTyped(json, false);
}

export function ReportingMelcoMachineStatisticsModelsValidateAccessTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoMachineStatisticsModelsValidateAccessToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': !exists(json, 'access_token') ? undefined : json['access_token'],
    };
}

export function ReportingMelcoMachineStatisticsModelsValidateAccessTokenToJSON(value?: ReportingMelcoMachineStatisticsModelsValidateAccessToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
    };
}


